import UserList from "./UserList"

// FEED RECEIVES AN OBJECT OF ALL USERS FROM User.js
// THEN RETURNS EACH USER IN THE OBJECT

const UserFeed = ({ users, initialUserId }) => {
	return (
		<fieldset style={{ width: "fit-content", margin: "0 auto" }}>
			<legend>Staff Members</legend>
			<table style={{ width: "fit-content", whiteSpace: "nowrap" }}>
				<tbody>
					<tr>
						<th>Lastname</th>
						<th>Firstname</th>
						<th>Email</th>
						<th>Phone</th>
						<th>Status</th>
						<th>Edit</th>
						<th>Modules</th>
					</tr>
					{users.map((user) => (
						<UserList key={user.id} user={user} initialUserId={initialUserId} />
					))}
				</tbody>
			</table>
		</fieldset>
	)
}

export default UserFeed
